import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { avisosStockApi } from '../api/avisosStock'
import { fmtFecha } from '../utils/fecha'
import { colors, text, sx } from '../design/tokens'

/**
 * Los más esperados (Martin, 8 sep 2026): productos agotados en ligier.com.ar
 * ordenados por cuánta gente pidió "avisame cuando vuelva" y sigue esperando.
 * Es demanda real para compras: cuando el producto vuelve, LGR manda los avisos
 * solo y la fila desaparece de acá.
 */
export default function StockMasEsperadosPage() {
  const navigate = useNavigate()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [err, setErr] = useState('')

  useEffect(() => {
    avisosStockApi.masEsperados()
      .then(({ data }) => setRows(data))
      .catch(() => setErr('No se pudo cargar la demanda de agotados.'))
      .finally(() => setLoading(false))
  }, [])

  const total = rows.reduce((a, r) => a + Number(r.esperan || 0), 0)

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 4 }}>
        <h1 style={{ margin: 0 }}>Los más esperados</h1>
        {rows.length > 0 && <span style={{ fontSize: text.sec, color: colors.textSec }}>{rows.length} productos · {total} personas esperando</span>}
      </div>
      <p style={{ margin: '0 0 16px', fontSize: text.sec, color: colors.textSec, maxWidth: 720 }}>
        Agotados en la web por los que alguien pidió aviso. Cuando el producto vuelve a tener stock, el mail sale solo a la mañana siguiente y la fila desaparece.
      </p>
      {err && <div style={{ color: colors.err, marginBottom: 10, fontSize: text.sec }}>{err}</div>}

      <div style={{ background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 10, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: text.body }}>
          <thead>
            <tr style={{ background: colors.bgSoft }}>
              {['Esperan', 'Producto', 'Bodega', 'Subrubro', 'Primer pedido', 'Último pedido'].map((h, i) => (
                <th key={h} style={{ ...sx.th, textAlign: i === 0 ? 'right' : 'left' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={6} style={{ padding: 24, textAlign: 'center', color: colors.textMeta }}>Cargando…</td></tr>}
            {!loading && rows.length === 0 && (
              <tr><td colSpan={6} style={{ padding: 24, textAlign: 'center', color: colors.textMeta }}>Nadie está esperando un agotado por ahora.</td></tr>
            )}
            {rows.map(r => (
              <tr key={r.articulo_id} onClick={() => navigate(`/articulos/${r.articulo_id}`)} title="Ver el artículo"
                style={{ cursor: 'pointer', borderBottom: `1px solid ${colors.borderSoft}` }}
                onMouseEnter={e => { e.currentTarget.style.background = colors.bgSoft }}
                onMouseLeave={e => { e.currentTarget.style.background = '' }}>
                <td style={{ padding: '10px 16px', ...sx.mono, textAlign: 'right', fontWeight: 700 }}>{r.esperan}</td>
                <td style={{ padding: '10px 16px' }}>
                  {r.descripcion}
                  <div style={{ ...sx.mono, fontSize: text.sec, color: colors.textMeta }}>{r.sku}</div>
                </td>
                <td style={{ padding: '10px 16px', color: colors.textSec }}>{r.bodega || '—'}</td>
                <td style={{ padding: '10px 16px', color: colors.textSec }}>{r.subrubro || '—'}</td>
                <td style={{ padding: '10px 16px', ...sx.mono, color: colors.textSec }}>{fmtFecha(r.primero)}</td>
                <td style={{ padding: '10px 16px', ...sx.mono, color: colors.textSec }}>{fmtFecha(r.ultimo)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
